export default __webpack_public_path__ + "static/media/Top-Mortgage-Lender (1).3bd2cd51.png";